import { Fragment, useState } from "react";
import { Rating } from "react-simple-star-rating";
import { Col, Row } from "reactstrap";
import { H5 } from "../../../../../AbstractElements";
import { RateNow } from "../../../../../Constants/Constants";

export const ProductRating = () => {
  const [rating, setRating] = useState(3);
  return (
    <Fragment>
      <Row>
        <Col md="4">
          <H5 className="product-title">{RateNow}</H5>
        </Col>
        <Col md="8">
          <div className="d-flex">
            <div className="rating">
              <Rating onClick={(newRating: number) => setRating(newRating)} initialValue={rating} size={17} />
            </div>
            <span className="ms-2">(250 review)</span>
          </div>
        </Col>
      </Row>
      <hr />
    </Fragment>
  );
};
